import {useEffect, useState} from "react";
import axios from "axios";
import {friendlyErrorMessage} from "./format.js";

/**
 * Lädt nur die Filter-Metadaten (GET /vertrieb/daten/filter), ohne den
 * vollen Filterzustand von useAnalysisFilters.js - für Seiten wie
 * "Kunde", die keine eigene Filterleiste zeigen, aber trotzdem den
 * Datenstand (Stichmonat, laufendes Jahr) für die Spaltenüberschriften und
 * den Knopf "Neu berechnen" brauchen.
 */
export default function useAnalysisMeta() {
    const [meta, setMeta] = useState(null);
    const [metaError, setMetaError] = useState(null);

    useEffect(() => {
        let active = true;
        axios
            .get("/vertrieb/daten/filter")
            .then(({data}) => {
                if (active) {
                    // Listen liegen auf oberster Ebene, Datenstand unter "meta"
                    // (siehe useAnalysisFilters.js).
                    setMeta({...data, ...(data?.meta || {})});
                }
            })
            .catch((e) => {
                if (active) {
                    setMetaError(friendlyErrorMessage(e, "Die Filteroptionen konnten nicht geladen werden."));
                }
            });
        return () => {
            active = false;
        };
    }, []);

    return {meta, metaError};
}
